<template>
  <div>
    <button class="exportCsv-button btn" style="
        color: var(--main-font-color);
        background-color: var(--main-bg-color);
        min-width: 5rem;
        height: 1.375rem;
        padding: 0 0.5rem;
        font-family: 'dfyuanstd-w7';
        font-size: 0.875rem;
        font-weight: normal;
      " @click="exportFile">
      {{ buttonName ? buttonName : "匯出Excel" }}
    </button>
  </div>
</template>

<script>
import { useStore } from "vuex";
import XLSX from "xlsx";
import XLSXStyle from "xlsx-style";
import FileSaver from "file-saver";
export default {
  props: {
    type: {
      type: String,
      default: "csv",
      validator: (value) => ["csv", "xlsx"].includes(value),
    },
    exportData: {
      type: Array,
      default: [],
    },
    exportDataTitle: {
      type: Array,
      default: [],
    },
    exportFileName: {
      type: String,
      default:
        new Date().getFullYear() +
        ("0" + (new Date().getMonth() + 1)).slice(-2) +
        ("0" + new Date().getDate()).slice(-2),
    },
    buttonName: {
      type: String,
    },
    autoCol: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();

    //dispatch
    const methods = {
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const exportCsv = () => {
      let dataTitle = props.exportDataTitle;
      let fileName = props.exportFileName;
      let exportData = props.exportData;

      if (dataTitle.length == 0 || fileName == "" || exportData.length == 0) {
        methods.setTimeoutAlert("無匯出資料");
        return;
      }

      let data = exportData.map((itemsdata) => Object.values(itemsdata));

      // 有/n的資料加上""，防止格式異常
      data.forEach((item, index) => {
        item.forEach((arrayItem, arrayIndex) => {
          if (
            data[index][arrayIndex] !== null &&
            typeof data[index][arrayIndex] === "string" &&
            data[index][arrayIndex].indexOf("\n") >= 0
          ) {
            data[index][arrayIndex] = '"' + data[index][arrayIndex] + '"';
          }
        });
      });

      //加表頭
      data.unshift(dataTitle);
      const csvContent = data.map((row) => row.join(",")).join("\n");
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvContent)
      );
      link.style = "visibility:hidden";
      link.download = fileName + ".csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const exportExcel = () => {
      let fileData = props.exportData;
      let fileName = props.exportFileName;
      console.log(fileData, fileName)
      if (fileData.length == 0 || fileName == "") {
        methods.setTimeoutAlert("無匯出資料");
        return;
      }
      const wb = XLSX.utils.book_new();

      fileData.forEach((item) => {
        let exportData = [];
        if (item.title.length != 0) {
          exportData.push(item.title);
        }
        item.data.forEach((rowData) => {
          exportData.push(rowData);
        });
        // console.log(item.title);
        let ws = XLSX.utils.aoa_to_sheet(exportData);
        if (item.merge != undefined) {
          ws["!merges"] = item.merge;
        }
        if (props.autoCol) {
          const ws_data = exportData.slice(4, 26);

          // 計算欄位寬度
          const wscols = ws_data.reduce((acc, row) => {
            row.forEach((cell, i) => {
              if (cell !== null && cell !== undefined) {
                // 檢查單元格是否為空
                const len = cell.toString().length; // 計算單元格文本的長度
                const chineseLen =
                  (cell.match(/[\u4e00-\u9fa5]/g) || []).length * 1.05;
                if (!acc[i] || acc[i] < len + chineseLen) {
                  acc[i] = len + chineseLen;
                }
              }
            });
            return acc;
          }, []);

          // 將寬度整理成一個陣列
          const colWidths = wscols.map((width) => ({ wch: width * 1.05 })); // 將每個列的寬度整理成 { wch: 寬度 * 1.2 } 的格式

          console.log(colWidths);
          ws["!cols"] = colWidths;
        }
        if (item.col != undefined) {
          ws["!cols"] = item.col;
        }
        XLSX.utils.book_append_sheet(wb, ws, item.sheetName);

        let range = XLSX.utils.decode_range(wb.Sheets[item.sheetName]["!ref"]);

        let excelStyle = item.excelStyle;
        if (excelStyle == undefined) {
          return;
        }
        for (let R = range.s.r; R <= range.e.r; ++R) {
          for (let C = range.s.c; C <= range.e.c; ++C) {
            let cell_address = { c: C, r: R };
            let cell_ref = XLSXStyle.utils.encode_cell(cell_address);

            // 通用樣式
            if (excelStyle.common !== undefined) {
              if (wb.Sheets[item.sheetName][cell_ref]) {
                let commonStyle = JSON.parse(JSON.stringify(excelStyle.common));
                wb.Sheets[item.sheetName][cell_ref].s = commonStyle;
              }
            }

            // 行數樣式
            if (excelStyle.R !== undefined) {
              if (excelStyle.R[R] !== undefined) {
                if (excelStyle.R[R] == null) {
                  continue;
                }
                let styleKey = Object.keys(excelStyle.R[R]);
                styleKey.forEach((data) => {
                  if (wb.Sheets[item.sheetName][cell_ref] == undefined) {
                    wb.Sheets[item.sheetName][cell_ref] = {};
                  }
                  if (wb.Sheets[item.sheetName][cell_ref].s == undefined) {
                    wb.Sheets[item.sheetName][cell_ref].s = {};
                  }
                  wb.Sheets[item.sheetName][cell_ref].s[data] =
                    excelStyle.R[R][data];
                });
              }
            }

            // 欄位樣式
            if (excelStyle.C !== undefined) {
              if (excelStyle.C[C] !== undefined) {
                if (excelStyle.C[C] == null) {
                  continue;
                }
                let styleKey = Object.keys(excelStyle.C[C]);
                styleKey.forEach((data) => {
                  if (wb.Sheets[item.sheetName][cell_ref] == undefined) {
                    wb.Sheets[item.sheetName][cell_ref] = {};
                  }
                  if (wb.Sheets[item.sheetName][cell_ref].s == undefined) {
                    wb.Sheets[item.sheetName][cell_ref].s = {};
                  }
                  wb.Sheets[item.sheetName][cell_ref].s[data] =
                    excelStyle.C[C][data];
                });
              }
            }

            // 指定樣式
            if (excelStyle.detail !== undefined) {
              if (excelStyle.detail[R + "-" + C] !== undefined) {
                if (excelStyle.detail[R + "-" + C] == null) {
                  continue;
                }
                let styleKey = Object.keys(excelStyle.detail[R + "-" + C]);
                styleKey.forEach((data) => {
                  if (wb.Sheets[item.sheetName][cell_ref] == undefined) {
                    wb.Sheets[item.sheetName][cell_ref] = {};
                  }
                  if (wb.Sheets[item.sheetName][cell_ref].s == undefined) {
                    wb.Sheets[item.sheetName][cell_ref].s = {};
                  }
                  wb.Sheets[item.sheetName][cell_ref].s[data] =
                    excelStyle.detail[R + "-" + C][data];
                });
              }
            }
          }
        }
      });
      let wbout = XLSXStyle.write(wb, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
      });

      const s2ab = (s) => {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
      };
      FileSaver.saveAs(
        new Blob([s2ab(wbout)], {
          type: "application/octet-stream",
        }),
        fileName + ".xlsx"
      );
    };

    const exportFile = () => {
      if (props.type == "csv") {
        exportCsv();
      } else if (props.type == "xlsx") {
        exportExcel();
      }
    };
    return {
      exportFile,
    };
  },
};
</script>

<style></style>
